import { LOGO_SMALL } from './constants';
import { useLang } from '../../contexts/LanguageContext';

export const Footer = () => {
  const { t } = useLang('footer');

  return (
    <footer className="border-t border-white/5 py-12 px-4 sm:px-6 lg:px-8 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-8">
          <img src={LOGO_SMALL} alt="Kaizen Kanri" className="h-10 w-auto rounded" />
          <p className="text-sm text-white/30">
            &copy; {new Date().getFullYear()} Kaizen Kanri. {t.tagline}
          </p>
        </div>
        <div className="pt-6 border-t border-white/5 text-center">
          <div className="flex items-center justify-center gap-4">
            <a href="/terms" className="text-xs text-white/40 hover:text-[#00CED1] transition-colors">{t.terms}</a>
            <span className="text-white/15">|</span>
            <a href="/privacy" className="text-xs text-white/40 hover:text-[#00CED1] transition-colors">{t.privacy}</a>
            <span className="text-white/15">|</span>
            <a href="/security" className="text-xs text-[#00CED1]/80 hover:text-[#00CED1] font-semibold transition-colors" data-testid="footer-security-link">{t.security}</a>
          </div>
        </div>
        <div className="pt-6 mt-6 border-t border-white/5 text-center space-y-1" data-testid="system-disclaimer">
          <p className="text-xs text-white/30">
            {t.method}
          </p>
          {t.language && (
            <p className="mx-auto max-w-3xl pt-2 text-xs leading-relaxed text-white/35" data-testid="footer-language-note">
              {t.language}
            </p>
          )}
          <p className="text-xs text-white/25">
            Kaizen Kanri &middot; KVK 42049431 &middot;{' '}
            <a href="https://kaizenkanri.nl" className="text-[#00CED1] hover:text-[#00CED1]/80 transition-colors" target="_blank" rel="noopener noreferrer">
              kaizenkanri.nl
            </a>
          </p>
          <p className="text-xs text-white/25" data-testid="footer-trademark">
            {t.trademark}
          </p>
        </div>
      </div>
    </footer>
  );
};
